export const GET_ENTITY = "GET_ENTITY";
export const ALL_ENTITY = "ALL_ENTITY";
export const EDIT_ENTITY = "EDIT_ENTITY";
export const ADD_ENTITY = "ADD_ENTITY";





